/*
 * Citera — recently-viewed.js
 * Renders the "recently viewed" grid from localStorage. Loaded (deferred) by
 * sections/recently-viewed.liquid only. Guarded so multiple section instances
 * don't double-bind. Recording happens on product pages (product.js).
 */
(function () {
  "use strict";
  if (window.CiteraRecentlyViewed) return;
  window.CiteraRecentlyViewed = true;
  var KEY = "citera:recent";
  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : s;
    return d.innerHTML;
  }

  function renderAll() {
    // Render into any recently-viewed section.
    document.querySelectorAll("[data-recently-viewed]").forEach(function (sec) {
      var current = sec.getAttribute("data-current");
      var limit = Number(sec.getAttribute("data-limit")) || 4;
      var ratio = sec.getAttribute("data-ratio") || "portrait";
      var showVendor = sec.getAttribute("data-show-vendor") === "true";
      var saleLabel = sec.getAttribute("data-sale-label") || "Sale price";
      var grid = sec.querySelector("[data-recently-viewed-grid]");
      if (!grid) return;
      var items = readRecent()
        .filter(function (p) {
          return p.handle !== current;
        })
        .slice(0, limit);
      if (!items.length) return;
      grid.innerHTML = items
        .map(function (p) {
          var img = "";
          if (p.image) {
            // The stored URL is the 400w rendition; derive a small srcset from it
            // so high-DPI screens get a sharp card image.
            var src400 = esc(p.image);
            var srcset =
              src400.replace(/width=\d+/, "width=200") + " 200w, " +
              src400 + " 400w, " +
              src400.replace(/width=\d+/, "width=600") + " 600w";
            img =
              '<img src="' + src400 + '" srcset="' + srcset +
              '" sizes="(min-width: 990px) 25vw, 50vw" alt="" loading="lazy">';
          }
          // Mirror snippets/product-card.liquid: vendor line reserved even when
          // blank, sale price in red with the compare-at struck through.
          var vendorLine = showVendor
            ? '<p class="product-card__vendor">' + (p.vendor ? esc(p.vendor) : "&nbsp;") + "</p>"
            : "";
          var priceHtml = p.compare_at
            ? '<span class="visually-hidden">' + esc(saleLabel) + "</span>" +
              '<span class="product-card__price-sale">' + esc(p.price) + "</span> " +
              '<s class="product-card__price-compare">' + esc(p.compare_at) + "</s>"
            : esc(p.price);
          return (
            '<li><div class="product-card"><a href="' +
            esc(p.url) +
            '" class="product-card__media product-card__media--' + esc(ratio) +
            '" tabindex="-1" aria-hidden="true">' +
            img +
            '</a><div class="product-card__info"><h2 class="product-card__title"><a href="' +
            esc(p.url) +
            '">' +
            esc(p.title) +
            '</a></h2><div class="product-card__price">' +
            priceHtml +
            "</div></div></div></li>"
          );
        })
        .join("");
      sec.hidden = false;
    });
  }
  renderAll();
  // Theme editor: sections injected live re-render.
  document.addEventListener("shopify:section:load", renderAll);
})();
